import { createAction } from '@shared/modules/event-bus/utils/create-action.util';
import { headerActionTypes } from '@shared/modules/header/actions/header.action-types';

export default {
  newEntityButtonClickAction: () => createAction(headerActionTypes.newEntityButtonClick),
};
